import { isAlphaNumericRegex } from '../../util/regularExpression';
export const stripProtocolFromUrl = url => {
  const len = url.length;
  if (len >= 7 && url.slice(0, 7) === 'mailto:' && isAlphaNumericRegex(url.charAt(7))) {
    return url.slice(7);
  }
  if (len >= 8 && url.slice(0, 8) === 'https://' && isAlphaNumericRegex(url.charAt(8))) {
    return url.slice(8);
  }
  if (len >= 7 && (url.slice(0, 7) === 'http://' || url.slice(0, 7) === 'ftps://') && isAlphaNumericRegex(url.charAt(7))) {
    return url.slice(7);
  }
  if (len >= 6 && url.slice(0, 6) === 'ftp://' && isAlphaNumericRegex(url.charAt(6))) {
    return url.slice(6);
  }
  return url;
};
//# sourceMappingURL=utils.js.map